import React, { useState } from "react";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addMembership } from "../../../redux/membership/action";
import {
  addMembershipValidation,
  discountaAddMembershipValidation,
} from "../../Constant/constant";
import Spinner from "../../Layouts/Spinner";
import {
  MEMBERSHIP_MARKETING_FEATURES,
  defaultMembershipMarketingFeatures,
} from "./membershipFeatures";

const AddMembership = () => {
  const [selectdurationtype, setselectdurationtype] = useState("");
  const [loading, setLoading] = useState(false);
  const [dis, setDis] = useState();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: "",
      ar_title: "",
      max_invoices: "",
      max_invoices1: "",
      max_invoices2: "",
      max_invoices3: "",
      max_invoices4: "",
      duration_type: "",
      duration: 1,
      price: "",
      discount: "",
      support_regular: 0,
      ...defaultMembershipMarketingFeatures,
      
    },
    validationSchema: dis
      ? discountaAddMembershipValidation
      : addMembershipValidation,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async (values) => {
    const data = {
      ...values,
    };
    if (!data.discount) {
      delete data.discount;
    }
    dispatch(addMembership(data, setLoading, navigate));
  };

  const handleGenderChange = (e) => {
    const gender = e.target.value;
    setselectdurationtype(gender);
    formik.setFieldValue("duration_type", Number(gender));
  };

  console.log(formik.values,"dfsfsfs")

  return (
    <div className="p-3">
      <h3 className="pb-3">Create Membership</h3>
      <div className=" category-wrapper">
        <form onSubmit={formik.handleSubmit}>
          <div className="row ">
            <div className="col-md-5">
              <div className="col-md-12 form-group">
                <label>Membership name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter title"
                  name="title"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.title}
                />
                {formik.touched.title && formik.errors.title ? (
                  <div className="error">{formik.errors.title}</div>
                ) : null}
              </div>

              <div className="col-md-12 form-group">
                <label>Membership Arabic name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter ar title"
                  name="ar_title"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.ar_title}
                />
                {formik.touched.ar_title && formik.errors.ar_title ? (
                  <div className="error">{formik.errors.ar_title}</div>
                ) : null}
              </div>

              <div className="form-group col-md-12">
                <label htmlFor="duration_type">Duration Type</label>
                <select
                  id="duration_type"
                  name="duration_type"
                  className="form-control"
                  onChange={handleGenderChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.duration_type}
                >
                  <option value="">Select Duration type</option>
                  <option value="1">Monthly</option>
                  <option value="2">Semi-Annual</option>
                </select>
                {formik.touched.duration_type && formik.errors.duration_type ? (
                  <div className="error">{formik.errors.duration_type}</div>
                ) : null}
              </div>
              {/* <div className="col-md-12 form-group">
                <label>Duration</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter duration"
                  name="duration"
                  id="duration"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.duration}
                />
                {formik.touched.duration && formik.errors.duration ? (
                  <div className="error">{formik.errors.duration}</div>
                ) : null}
              </div> */}

              <div className="col-md-12 form-group">
                <label>Price (SAR)</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter price"
                  name="price"
                  id="price"
                  min="0"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.price}
                />
                {formik.touched.price && formik.errors.price ? (
                  <div className="error">{formik.errors.price}</div>
                ) : null}
              </div>
              <div className="col-md-12 form-group">
                <label>Discount % (optional)</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter discount"
                  name="discount"
                  max="100"
                  min="0"
                  id="discount"
                  onChange={(e) => {
                    formik.handleChange(e);
                    setDis(e.target.value);
                  }}
                  onBlur={formik.handleBlur}
                  value={formik.values.discount}
                />
                {formik.touched.discount && formik.errors.discount ? (
                  <div className="error">{formik.errors.discount}</div>
                ) : null}
              </div>
            </div>
            <div className=" col-md-7 d-flex justify-content-center">
              <div className="table-responsive  ">
                <table className="table">
                  <thead>
                    <th>Invoice Type</th>
                    <th>Limited Number</th>
                    <th>Unlimited Number</th>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Simplified</td>
                      <td>
                        {formik.values.max_invoices !== 10000 && (
                          <>
                            <input
                              type="number"
                              className={`form-control ${
                                formik.touched.max_invoices &&
                                formik.errors.max_invoices
                                  ? "is-invalid"
                                  : ""
                              }`}
                              placeholder="Enter invoice..."
                              name="max_invoices"
                              min="0"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.max_invoices}
                            />
                            {formik.touched.max_invoices &&
                              formik.errors.max_invoices && (
                                <div className="error">
                                  {formik.errors.max_invoices}
                                </div>
                              )}
                          </>
                        )}
                      </td>
                      <td className="checkbox-input">
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            formik.setFieldValue(
                              "max_invoices",
                              e.target.checked ? 10000 : ""
                            );
                          }}
                          checked={formik.values.max_invoices === 10000}
                        />
                      </td>
                    </tr>

                    <tr>
                      <td>VAT</td>
                      <td>
                        {formik.values.max_invoices1 !== 10000 && (
                          <>
                            <input
                              type="number"
                              className={`form-control ${
                                formik.touched.max_invoices1 &&
                                formik.errors.max_invoices1
                                  ? "is-invalid"
                                  : ""
                              }`}
                              min="0"
                              placeholder="Enter invoice..."
                              name="max_invoices1"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.max_invoices1}
                            />
                            {formik.touched.max_invoices1 &&
                              formik.errors.max_invoices1 && (
                                <div className="error">
                                  {formik.errors.max_invoices1}
                                </div>
                              )}
                          </>
                        )}
                      </td>
                      <td className="checkbox-input">
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            formik.setFieldValue(
                              "max_invoices1",
                              e.target.checked ? 10000 : ""
                            );
                          }}
                          checked={formik.values.max_invoices1 === 10000}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Purchase</td>
                      <td>
                        {formik.values.max_invoices2 !== 10000 && (
                          <>
                            <input
                              type="number"
                              className={`form-control ${
                                formik.touched.max_invoices2 &&
                                formik.errors.max_invoices2
                                  ? "is-invalid"
                                  : ""
                              }`}
                              min="0"
                              placeholder="Enter invoice..."
                              name="max_invoices2"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.max_invoices2}
                            />
                            {formik.touched.max_invoices2 &&
                              formik.errors.max_invoices2 && (
                                <div className="error">
                                  {formik.errors.max_invoices2}
                                </div>
                              )}
                          </>
                        )}
                      </td>
                      <td className="checkbox-input">
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            formik.setFieldValue(
                              "max_invoices2",
                              e.target.checked ? 10000 : ""
                            );
                          }}
                          checked={formik.values.max_invoices2 === 10000}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Credit Notes</td>
                      <td>
                        {formik.values.max_invoices3 !== 10000 && (
                          <>
                            <input
                              type="number"
                              className={`form-control ${
                                formik.touched.max_invoices2 &&
                                formik.errors.max_invoices2
                                  ? "is-invalid"
                                  : ""
                              }`}
                              min="0"
                              placeholder="Enter credit note..."
                              name="max_invoices3"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.max_invoices3}
                            />
                            {formik.touched.max_invoices3 &&
                              formik.errors.max_invoices3 && (
                                <div className="error">
                                  {formik.errors.max_invoices3}
                                </div>
                              )}
                          </>
                        )}
                      </td>
                      <td className="checkbox-input">
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            formik.setFieldValue(
                              "max_invoices3",
                              e.target.checked ? 10000 : ""
                            );
                          }}
                          checked={formik.values.max_invoices3 === 10000}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Debit Notes</td>
                      <td>
                        {formik.values.max_invoices4 !== 10000 && (
                          <>
                            <input
                              type="number"
                              className={`form-control ${
                                formik.touched.max_invoices2 &&
                                formik.errors.max_invoices2
                                  ? "is-invalid"
                                  : ""
                              }`}
                              min="0"
                              placeholder="Enter debit note..."
                              name="max_invoices4"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.max_invoices4}
                            />
                            {formik.touched.max_invoices4 &&
                              formik.errors.max_invoices4 && (
                                <div className="error">
                                  {formik.errors.max_invoices4}
                                </div>
                              )}
                          </>
                        )}
                      </td>
                      <td className="checkbox-input">
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            formik.setFieldValue(
                              "max_invoices4",
                              e.target.checked ? 10000 : ""
                            );
                          }}
                          checked={formik.values.max_invoices4 === 10000}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>Plan Benefit</th>
                      <th>Arabic Label</th>
                      <th>Included</th>
                    </tr>
                    {MEMBERSHIP_MARKETING_FEATURES.map((feature) => (
                      <tr key={feature.field}>
                        <td>{feature.label}</td>
                        <td dir="rtl">{feature.arLabel}</td>
                        <td className="checkbox-input">
                          <input
                            type="checkbox"
                            onChange={(event) => {
                              formik.setFieldValue(
                                feature.field,
                                event.target.checked ? 1 : 0
                              );
                            }}
                            checked={formik.values[feature.field] === 1}
                          />
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td>Business Hours Support</td>
                      <td>
                      </td>
                      <td className="checkbox-input">
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            formik.setFieldValue(
                              "support_regular",
                              e.target.checked ? 1 : 0
                            );
                          }}
                          checked={formik.values.support_regular === 1}
                        />
                      </td>
                    </tr>
                    
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div
            className="d-flex align-items-center justify-content-center mt-3  "
            style={{ columnGap: "20px" }}
          >
            <button
              className="submit-btn  "
              onClick={() => {
                navigate("/membership");
              }}
              style={{ width: "max-content" }}
            >
              Back
            </button>
            <button
              className="submit-btn   "
              style={{ width: "max-content" }}
              type="submit"
            >
              {!loading ? "Submit" : <Spinner />}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddMembership;
